/**
 * Decides how to establish a Supabase session from a staff-auth response.
 *
 * The backend now mints the session server-side and returns access/refresh
 * tokens, because newer browser supabase-js (2.10x) rejects the magic-link
 * `verifyOtp({ token_hash, type: 'email' })` call with a bogus 403
 * `otp_expired` — which silently broke every staff login. Prefer the tokens;
 * fall back to the legacy `token_hash` only for older backends mid-rollout.
 */

export interface StaffAuthResponse {
  access_token?: string
  refresh_token?: string
  token_hash?: string
}

export type SessionCredentials =
  | { mode: 'session'; accessToken: string; refreshToken: string }
  | { mode: 'token_hash'; tokenHash: string }
  | { mode: 'none' }

export function resolveSessionCredentials (data: StaffAuthResponse | null | undefined): SessionCredentials {
  if (data?.access_token && data?.refresh_token) {
    return { mode: 'session', accessToken: data.access_token, refreshToken: data.refresh_token }
  }
  if (data?.token_hash) {
    return { mode: 'token_hash', tokenHash: data.token_hash }
  }
  return { mode: 'none' }
}
